/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { Modal } from 'antd-mobile'
import { AUTHENTICATION_TYPE } from 'adv-protocol/src/GameCommon'
// img
import IPinImg from '@assets/images/icon/etc_icon/i-pin.png'
import PhoneImg from '@assets/images/icon/etc_icon/phone.png'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { AdvDialogStyle, SelectTypeModal } from '@styles/modal'


const SelectCertificationPopup: React.FC = () => {
  const { globalStore, authStore } = useRootStore()
  const { visibleSelectCertification } = globalStore


  const onCloseModal = () => {
    globalStore.setVisibleSelectCertification(false)
  }

  const onClickAuthentication = (type: AUTHENTICATION_TYPE) => {
    authStore.showAuthenticationPopup(type)
  }

  return (
    <Modal
      transparent
      visible={visibleSelectCertification}
      maskClosable={false}
      onClose={onCloseModal}
      css={AdvDialogStyle}
      className="custom-dialog white-dialog small-size"
      title="본인 인증"
    >
      <SelectTypeModal className="setting-limit">
        <Button className="select-type-btn" onClick={() => onClickAuthentication(AUTHENTICATION_TYPE.I_PIN)}>
          <img src={IPinImg} alt="아이핀 인증"/>
          아이핀 인증
        </Button>
        <Button className="select-type-btn" onClick={() => onClickAuthentication(AUTHENTICATION_TYPE.PHONE)}>
          <img src={PhoneImg} alt="휴대폰 인증"/>
          휴대폰 인증
        </Button>
      </SelectTypeModal>

      <ModalBg onClick={onCloseModal}/>
    </Modal>
  )
}

export default observer(SelectCertificationPopup)
